<template>
  <div class="codes-relationship">
    <div class="columns">
      <div class="column is-12">
        <div class="columns">
          <div class="column is-half">
            <parent-codes
              :parentCodechecked.sync="parentCodeChecked"
              :firm="firm"
              @assignCodes="onAssignCodes"
              ref="parentCodes"
            />
          </div>
          <div class="column is-half">
            <child-codes
            :firm="firm"
            :childCodeChecked.sync="childCodeChecked" ref="childCodes"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parentCodes from "./partials/parentCodes";
import childCodes from "./partials/childCodes";
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: [ 'firm' ],
  codeService: CodeService,
  data: () => ({
    parentCodeChecked: [],
    childCodeChecked: []
  }),
  components: {
    parentCodes,
    childCodes
  },
  methods: {
    async onAssignCodes() {
      try {
        const parentIds = this.parentCodeChecked.map(code => {
          return code.id;
        });
        const childIds = this.childCodeChecked.map(code => {
          return code.id;
        });
        // update Parent Codes
        const parentCodes = await this.$options.codeService
          .syncParentsChilds({
            parent_ids: parentIds,
            child_ids: childIds,
            includes: "childCodes"
          })
          .then(response => JsonDenormalizer.denormalize(response));

        this.$refs.parentCodes.assigning = false;

        // refresh table
        this.$buefy.toast.open({
          message: "Parent Codes Updated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/codeConfigurator/index.vue